/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. It only decodes the header and payload so you can read them. Verifying a JWT requires the signing secret or public key, which this tool never asks for. Do not treat a decoded token as authenticated.`)
};

const es_jw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Solo decodifica el encabezado y la carga útil para que puedas leerlos. Verificar un JWT requiere el secreto de firma o la clave pública, que esta herramienta nunca solicita. No trates un token decodificado como autenticado.`)
};

const de_jw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Es dekodiert nur Header und Payload, damit Sie sie lesen können. Die Verifizierung eines JWT erfordert das Signaturgeheimnis oder den öffentlichen Schlüssel, nach denen dieses Tool niemals fragt. Betrachten Sie ein dekodiertes Token nicht als authentifiziert.`)
};

const nl_jw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Het decodeerdt alleen de header en payload zodat u ze kunt lezen. Het verifiëren van een JWT vereist het ondertekeningsgeheim of de openbare sleutel, die dit hulpmiddel nooit vraagt. Behandel een gedecodeerd token niet als geverifieerd.`)
};

const fr_jw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Il décode uniquement l'en-tête et la charge utile pour que vous puissiez les lire. Vérifier un JWT nécessite le secret de signature ou la clé publique, que cet outil ne demande jamais. Ne traitez pas un jeton décodé comme authentifié.`)
};

const it_jw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Decodifica solo l'intestazione e il payload in modo da poterli leggere. La verifica di un JWT richiede il segreto di firma o la chiave pubblica, che questo strumento non richiede mai. Non trattare un token decodificato come autenticato.`)
};

const pt_br2_jw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Ele apenas decodifica o cabeçalho e o payload para que você possa lê-los. Verificar um JWT requer o segredo de assinatura ou a chave pública, que esta ferramenta nunca pede. Não trate um token decodificado como autenticado.`)
};

const pt_jw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Apenas descodifica o cabeçalho e carga para que possa lê-los. A verificação de um JWT requer o segredo de assinatura ou a chave pública, que esta ferramenta nunca solicita. Não trate um token descodificado como autenticado.`)
};

const ja_jw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。ヘッダーとペイロードをデコードしてそれらを読むだけです。JWTを検証するにはシグネチャシークレットまたは公開キーが必要ですが、このツールはそれを要求しません。デコード済みトークンを認証されたものとして扱わないでください。`)
};

const zh_jw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。它只解码头部和载荷，方便你阅读。验证 JWT 需要签名密钥或公钥，而此工具从不会索要这些信息。请勿将解码后的令牌视为已通过身份验证。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_faq1_a", locale)
	if (locale === "en") return en_jw_faq1_a(inputs)
	if (locale === "es") return es_jw_faq1_a(inputs)
	if (locale === "de") return de_jw_faq1_a(inputs)
	if (locale === "nl") return nl_jw_faq1_a(inputs)
	if (locale === "fr") return fr_jw_faq1_a(inputs)
	if (locale === "it") return it_jw_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_jw_faq1_a(inputs)
	if (locale === "pt") return pt_jw_faq1_a(inputs)
	if (locale === "ja") return ja_jw_faq1_a(inputs)
	return zh_jw_faq1_a(inputs)
};